import "./config";
import "./styles.css";
import "./styles.global.css";

const SUPPORTED_STOREFRONT_TYPES = ["custom-lightopia", "miva"] as const;
type SupportedStorefrontType = (typeof SUPPORTED_STOREFRONT_TYPES)[number];

(async () => {
  const scriptUrl = new URL(
    // eslint-disable-next-line @typescript-eslint/no-unsafe-type-assertion
    (document.currentScript as HTMLScriptElement).src,
    location.href,
  );
  const params = new URLSearchParams(new URL(scriptUrl, location.href).search);

  const storefrontType = params.get("storefront_type");
  const widgetId = params.get("widget_id");
  if (!widgetId) {
    throw new Error("widget_id not included in storefront embed script URL");
  }

  globalThis.redoWidgetId = widgetId;

  if (!storefrontType) {
    throw new Error(
      "storefront_type not included in storefront embed script URL",
    );
  }

  if (
    !(SUPPORTED_STOREFRONT_TYPES as readonly string[]).includes(storefrontType)
  ) {
    throw new Error("Invalid storefront type: " + storefrontType);
  }
  // eslint-disable-next-line @typescript-eslint/no-unsafe-type-assertion
  const supportedType = storefrontType as SupportedStorefrontType;

  if (globalThis.redoStorefront) {
    globalThis.redoStorefront.type = supportedType;
  } else {
    globalThis.redoStorefront = {
      type: supportedType,
      storeUrl: location.host,
    };
  }

  // Assigned before the extension loads so the client factory sees it, but a
  // missing store_code is deliberately NOT fatal here: throwing would skip the
  // import below, and the factory's MIVA_STORE_CODE_MISSING diagnostic would
  // never be reachable.
  if (supportedType === "miva") {
    const storeCode = params.get("store_code");
    if (storeCode) {
      globalThis.redoStorefront.miva = {
        root: params.get("miva_root") ?? undefined,
        storeCode,
      };
    }
  }

  await import("@redotech/redo-shopify-extension/index");
  console.log("Redo storefront embed bootstrap initialized.");
})();
